import React, { useState } from 'react';
import PositionsPivotTable from '../components/positions/PositionsPivotTable';
import PositionsFlatGrid from '../components/positions/PositionsFlatGrid';

import './Positions.css';
import PageShell from '../components/layout/PageShell';
import PostionsSP from "../components/positions/PositionsSP";
import SPMatrixGrid from "../components/positions/SPMatrixGrid";

type ViewType = 'positions' | 'positions_pivot' | 'positions_sp' | null;

const PositionsPositions: React.FC = () => {
  const [activeView, setActiveView] = useState<ViewType>('positions');
  const handleNavClick = (view: ViewType): void => {
    setActiveView(prev => (prev === view ? null : view));
  };

  return (
    <PageShell>

      <div className="nav-bar">
        <div
          className={`nav-item ${activeView === 'positions' ? 'active' : ''}`}
          onClick={() => handleNavClick('positions')}
        >
          Positions
        </div>
        <div
          className={`nav-item ${activeView === 'positions_pivot' ? 'active' : ''}`}
          onClick={() => handleNavClick('positions_pivot')}
        >
          Positions Pivot
        </div>
        <div
          className={`nav-item ${activeView === 'positions_sp' ? 'active' : ''}`}
          onClick={() => handleNavClick('positions_sp')}
        >
          Structured Products
        </div>


      </div>

      <div
        className="content-container"
        style={{ display: activeView === 'positions' ? 'block' : 'none' }}
        aria-hidden={activeView !== 'positions'}
      >
        <button className="close-button" onClick={() => setActiveView(null)}>×</button>
        <PositionsFlatGrid />
      </div>

      <div
        className="content-container"
        style={{ display: activeView === 'positions_pivot' ? 'block' : 'none' }}
        aria-hidden={activeView !== 'positions_pivot'}
      >
        <button className="close-button" onClick={() => setActiveView(null)}>×</button>
        <PositionsPivotTable />
      </div>

      <div
          className="content-container"
          style={{ display: activeView === 'positions_sp' ? 'block' : 'none' }}
          aria-hidden={activeView !== 'positions_sp'}
      >
        <button className="close-button" onClick={() => setActiveView(null)}>×</button>
        <SPMatrixGrid />
        <PostionsSP />
      </div>
    </PageShell>
  );
};

export default PositionsPositions;